import React, { useState, useContext } from 'react'
import { giphyLightGrey } from '@giphy/js-brand'
import styled from 'styled-components'
import TabNavigation from '../../../../navigation-tabs'
import Details from './details'
import Advanced from './advanced'
import { CreationCaptureInfoContext } from './manager'
import { CreationToolsContext } from '../../../../../manager'
import Metadata from './metadata'
import Watermark from './watermark'
import Font from './custom-font'
import CreationToolSuperCutSection from '../../../../../types/super-cut-section'
import CreationToolUserRestriction from '../../../../../types/user-restriction'

const FILE_UPOAD_SECTIONS = {
    watermark: {
        title: 'Watermark',
        Component: Watermark,
    },
    font: {
        title: 'Custom Font',
        Component: Font,
    },
}

const Container = styled.div`
    color: ${giphyLightGrey};
`

type Props = {
    className?: string
    isEditMode?: boolean
}

const CreationCaptureInfoSections = ({ className, isEditMode }: Props) => {
    const [activeSectionIndex, setActiveSectionIndex] = useState<number>(0)
    const { userRestrictionAccess } = useContext(CreationToolsContext)
    const { isWatermarkOpen, isCustomFontOpen } = useContext(CreationCaptureInfoContext)

    // filter out any fields that the user doesn't have access to.
    const filteredSections = CreationToolSuperCutSection.all().filter(section => {
        const userRestriction = CreationToolSuperCutSection.userRestriction(section)
        const hasAccess = CreationToolUserRestriction.hasAccess(userRestriction, userRestrictionAccess)
        const isEditable = CreationToolSuperCutSection.isEditable(section, isEditMode)
        return hasAccess && isEditable
    })

    // map sections to components
    const sectionComponents = filteredSections.map(section => {
        switch (section) {
            case CreationToolSuperCutSection.Capture:
                return Details
            case CreationToolSuperCutSection.Advanced:
                return Advanced
            case CreationToolSuperCutSection.Metadata:
                return Metadata
        }
    })

    const Section = isWatermarkOpen
        ? FILE_UPOAD_SECTIONS.watermark.Component
        : isCustomFontOpen
        ? FILE_UPOAD_SECTIONS.font.Component
        : sectionComponents[activeSectionIndex]
    const labels = isWatermarkOpen
        ? [FILE_UPOAD_SECTIONS.watermark.title]
        : isCustomFontOpen
        ? [FILE_UPOAD_SECTIONS.font.title]
        : filteredSections.map(CreationToolSuperCutSection.title)

    return (
        <Container className={className}>
            <TabNavigation labels={labels} onChange={setActiveSectionIndex} />
            <Section isEditMode={isEditMode} />
        </Container>
    )
}

export default CreationCaptureInfoSections
